<template>
    <div class="page">
        <div class="head-title">
            <div class="left">
                <ul class="breadcrumb">
                    <li>
                        <router-link to="/accounting/home" class="active">{{
                            $t("accounting")
                            }}</router-link>
                    </li>
                    <li>-</li>
                    <li>
                        <router-link to="/accounting/JournalEntry" class="active">{{
                            $t("JL")
                            }}</router-link>
                    </li>
                </ul>
            </div>
        </div>
        <div class="main">
            <div class="head">
                <div class="head1">
                    <input type="text" :placeholder="$t('number') + ' ' + $t('JL')" v-model="jlnumber" />
                    <input type="date" :placeholder="$t('date') + ' ' + $t('JL')" v-model="jldate" />
                    <input type="text" :placeholder="$t('number') + ' ' + $t('ccenter')" />
                    <input type="text" :placeholder="$t('description')" v-model="jldescription" />
                    <button type="submit" @click="datesearch">
                        <i class="bi bi-search"></i> {{ $t("search") }}
                    </button>
                </div>
                <div class="head2">
                    <button>
                        <router-link to="/accounting/JournalEntry/CreateJournalEntry">+ {{ $t("add") }} {{ $t("JL")
                            }}</router-link>
                    </button>
                </div>
            </div>
            <div class="body">
                <table class="table">
                    <thead>
                        <tr>
                            <th>{{ $t("code") }}</th>
                            <th>{{ $t("date") }} {{ $t("creation") }}</th>
                            <th>{{ $t("date") }} {{ $t("transaction") }} </th>
                            <th>{{ $t("description") }}</th>
                            <th>{{ $t("status") }}</th>
                            <th>{{ $t("total") }} {{ $t("amount") }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="val in data" :key="val">
                            <td v-if="val.review != 'cancel'"><router-link
                                    :to="`/accounting/JournalEntry/JournalEntryReview/${val.jid}`" class="active">MJ-{{
                                    val.jid }}</router-link></td>
                            <td v-if="val.review == 'cancel'">MJ-{{
                                val.jid }}</td>
                            <td>{{ val.date }}</td>
                            <td>{{ val.trandate }}</td>
                            <td>{{ val.description }}</td>
                            <td v-if="val.review == 'waiting'" style="
                      font-weight: bold;
                      background-color: yellow;
                      color: black;
                    ">
                                {{ $t(val.review) }}
                            </td>
                            <td v-if="val.review == 'confirmed'"
                                style="font-weight: bold; background-color: green; color: white">
                                {{ $t(val.review) }}
                            </td>
                            <td v-if="val.review == 'cancel'"
                                style="font-weight: bold; background-color: red; color: white">
                                {{ $t(val.review) }}
                            </td>
                            <td>{{ val.totaldpt }}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="pagination">
                    <button :disabled="currentPage === 1" @click="prevPage">{{ $t("previous") }}</button>
                    <span>{{ $t("page") }} {{ currentPage }} {{ $t("of") }} {{ totalPages }}</span>
                    <button :disabled="currentPage === totalPages" @click="nextPage">{{ $t("next") }}</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// import store from "@/store";
import axios from "axios";
// import Swal from "sweetalert2";
import { mapActions } from "vuex";
export default {
  props: ["css"],
  components: {},
  data() {
    return {
      name: "",
      status: "",
      mobile: "",
      code: "",
      data: [],
      jlnumber: "",
      jldate: "",
      jldescription: "",
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,

    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalItems / this.pageSize);
    },
  },

  //   async mounted() {
  //     const result = await axios.get("/data/alljournalentry");
  //     if (result.status == 200) {
  //       this.data = result.data.data;
  //       this.data2 = result.data.data;
  //     }
  //   },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    view(row) {
      this.$root.$router.push({
        path: `/AdminDashboard/JournalEntry/JournalEntryReview/${row.jid}`,
      });
    },
    // async datesearch() {
    //   this.data = {}
    //   const result = await axios.post("/data/alljournalentry", {
    //     id: this.jlnumber,
    //     date: this.jldate,
    //     description: this.jldescription
    //   });
    //   if (result.status == 200) {
    //     this.data = result.data.data;
    //   }
    // },
    ...mapActions(["redirectTo"]),
    async fetchData() {
      try {
        console.log("this.currentPage...",this.currentPage);
                console.log("this.pageSize...",this.pageSize);

          const response = await axios.get("/data/alljournalentry", {
          params: {
            id: this.jlnumber || undefined,
            date: this.jldate || undefined,
            description: this.jldescription || undefined,
            page: this.currentPage,
            limit: this.pageSize,
          },
        });
        if (response.status === 200) {
          this.data = response.data.data;
          this.totalItems = response.data.total;
        }
      } catch (error) {
        console.error("Error fetching journal entries:", error);
      }
    },
        datesearch() {
      this.currentPage = 1; // Reset to first page on new search
      this.fetchData();
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.fetchData();
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.fetchData();
      }
    },
  },
  watch: {
    name() {
      this.table.rows = this.table.data.filter((x) =>
        x.namear.includes(this.name.toLowerCase())
      );
    },

    status() {
      this.table.rows = this.table.data.filter((x) => x.review == this.status);
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
    // direction: v-bind("css.EN");
    padding: 0.5%;
}

.main {
    width: 98%;
    margin: 1%;
    padding: 1%;
    // box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    border-radius: 5px;
    border: ridge 0.5px;
}

.head {
    padding: 0.25%;
    display: flex;
    border-bottom-style: ridge;
}

.head1 {
    width: 70%;
}

.head1 input {
    margin: 0.5%;
    padding: 0.5%;
    border: none;
    border-radius: 5px;
    background-color: #eee;
}

.head2 {
    width: 30%;
    text-align: center;
}

.head2 button {
    margin: 0.5%;
    padding: 1%;
    border: none;
    border-radius: 5px;
    background-color: rgba(98, 153, 174, 255);
    color: white;
}

.head2 button a {
    color: white;
}

.table {
    margin-top: 1%;
}

table thead tr {
    border-radius: 5px;
    background-color: #eee;
}

button {
    margin: 0.5%;
    padding: 1%;
    border: none;
    border-radius: 5px;
    background-color: rgba(98, 153, 174, 255);
    color: white;
}
.pagination {
  margin-top: 1%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.pagination button {
  padding: 0.5% 1%;
  background-color: rgba(98, 153, 174, 255);
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.pagination button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.pagination span {
  font-size: 1rem;
}

</style>
